var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _radialGradient, _path8, _linearGradient, _path9, _radialGradient2, _path10, _linearGradient2, _path11, _path12, _path13, _path14, _linearGradient3, _path15, _path16, _path17, _path18, _radialGradient3, _path19, _path20, _path21, _linearGradient4, _path22, _g, _linearGradient5, _path23, _linearGradient6, _path24, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClimbing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.21 55.04c-.07-.05-7.56-4.97-11.74-22.19c-2.49-10.23-2.8-21.32-2.64-28.81h-1.6c-.17 7.6.16 18.82 2.68 29.19C55.27 51.17 63.03 56.2 63.35 56.4c.13.08.28.12.42.12c.27 0 .53-.13.68-.37c.25-.38.14-.87-.24-1.11z",
    fill: "#1c75bc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.17 39.21a.5.5 0 0 0-.22-.31l-9.81-6.37l-8.05-12.8c-.12-.2-.37-.28-.59-.2l-2.59.91c-.48.17-.87.53-1.07 1c-.2.47-.2 1 .01 1.46l6.03 13.52l.03.06c.28.63.73 1.16 1.3 1.54l10.73 7.06c.08.05.18.08.28.08c.03 0 .07 0 .1-.01c.13-.03.24-.1.32-.22l3.46-5.33c.07-.12.09-.26.07-.39z",
    fill: "#ba8f63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.14 32.53l-4.03 6.98l7.39 3.95c2.16 1.35 5.06.5 6.2-1.34c1.14-1.84.18-5.11-.71-5.67l-8.85-3.92z",
    fill: "#db5200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.89 20.85c-.44-4.23-3.78-8.97-7.85-10.2c-4.56-1.38-8.31.54-10.77 4.08c-.89 1.28-1.53 2.69-1.77 3.8c-.03.13-.21 1.1-.33 1.38c-.35 1.11-2.86 1.16-3.65 2.18c-.6.77.94 2.2 1.01 2.43c.33 1.12-1.79 3.9 1.33 6.24c.8.6 3.51 1.03 3.51 1.03c1.54 1.04-.07 4.91-.07 4.91l8.71 1.42s-1.44-3.65 2.78-6.56c3.23-2.23 7.39-7.99 7.1-10.71z",
    fill: "#e0bb95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.14 26.99c.67.38 1.51.55 2.3.41c.86-.16.68-.89-.19-.94c-.53-.03-1.34-.32-1.85-.7l-.26 1.23z",
    fill: "#6d4c41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-66.096 66.96 21.991)",
    cx: 66.96,
    cy: 21.99,
    rx: 1.54,
    ry: 1.01,
    fill: "#5d4037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.25 19.84c-1.03-.02-1.05-.71-.58-1.11c.35-.29 1.01-.42 2.04.14c.97.53 1.21 1.25 1.38 1.7s.02.8-.23.75c-.35-.04-1.35-1.44-2.61-1.48z",
    fill: "#ab872f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.56 30.69c.14-.06.29-.12.46-.21c2.09-.96 2.55-3.78 2.77-5.81c.03-.26.04-.53.06-.8c.02-.31.06-.61.07-.92c.01-.66-.02-1.31-.14-1.95c-.08-.45-.21-.9-.36-1.34c-.16-.43-.35-.86-.56-1.27c-.17-.34-.37-.66-.57-.98l-.18-.27c-.17-.25-.35-.49-.53-.72c-.06-.07-.11-.14-.17-.21c-.24-.29-.5-.57-.77-.83c-.06-.06-.12-.11-.18-.16c-.22-.21-.46-.41-.69-.6c-.05-.04-.09-.08-.14-.12c-.04-.03-.09-.06-.14-.1c-.19-.14-.38-.28-.58-.41l-.27-.18c-.29-.18-.59-.35-.9-.5c-2.2-1.08-4.78-1.39-7.15-.77c-.46.12-.92.28-1.35.49c-.22.1-.43.22-.64.34c-.61.37-1.16.85-1.56 1.41c-.13.19-.25.39-.35.59s-.18.43-.25.66c.87.34 1.87.14 2.78.58c.88.43 1.72 1 2.64 1.3c.31.1.62.17.94.19c.33.02.67 0 1-.01c.17-.01.34-.02.5-.02c.09.04.15.07.15.07c.07.09.11.19.15.28c.24.73-.38 1.67-1 2.73c-.08.13-.15.27-.23.41c-.11.2-.21.4-.31.6c-.1.2-.19.41-.26.62c-.06.16-.1.32-.14.48c-.11.49-.14.99-.02 1.5a7.539 7.539 0 0 0 .35 1.08s.28-.48.72-.92c.07-.08.15-.15.24-.22c.13-.11.26-.21.4-.29c.14-.08.28-.14.43-.18c.11-.03.21-.05.32-.05c.26-.01.54.07.82.28c.06.04.1.08.15.13a1.199 1.199 0 0 1 .22.23c.03.04.07.07.09.11c.03.04.05.08.07.12c.02.04.05.08.07.11c.02.04.03.09.05.13c.01.04.03.08.04.11c.01.04.02.09.02.13c.01.04.02.08.02.12v.25c0 .05-.01.09-.02.14c-.01.04-.01.08-.02.12c-.01.05-.03.1-.04.14c-.01.04-.02.07-.04.11c-.02.05-.04.1-.07.15c-.02.04-.03.07-.05.11c-.02.05-.05.09-.08.14c-.02.04-.04.07-.07.11c-.03.05-.07.09-.1.14c-.03.03-.05.07-.07.1l-.12.15c-.03.03-.05.06-.08.09c-.04.05-.09.09-.13.14l-.09.09c-.05.04-.1.09-.14.13c-.03.03-.06.06-.1.09c-.06.05-.12.1-.19.15c-.02.02-.04.03-.07.05c-.09.07-.18.13-.27.19c-1.5 1.02-1.9-.05-1.98.6c-.1.16-.24.56-.37.95l-.01.02c-.17.49-.31.97-.31.97h.01l-.18.58c-.15.77-.01 1.68.81 2.51c.4.41 1.15.61 1.6.7c.15.43.51 1.17 1.25 1.56c.32.17.67.26 1.05.26c.39 0 .8-.09 1.24-.27l.82-.33s-1.13-.45-1.08-1.72c1.61 1.2 3.32-.18 3.36-.22l.62-.56l-.76-.29c-.29-.1-.81-.44-.9-.73c-.35-1.03.42-1.52.49-1.58z",
    fill: "#ab872f"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab16176",
    cx: 74.441,
    cy: 104.018,
    r: 14.223,
    gradientTransform: "matrix(.0248 .9997 .8943 -.0222 -20.425 -48.126)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#bfa055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfa055"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.56 30.69c.14-.06.29-.12.46-.21c2.09-.96 2.55-3.78 2.77-5.81c.03-.26.04-.53.06-.8c.02-.31.06-.61.07-.92c.01-.66-.02-1.31-.14-1.95c-.08-.45-.21-.9-.36-1.34c-.16-.43-.35-.86-.56-1.27c-.17-.34-.37-.66-.57-.98l-.18-.27c-.17-.25-.35-.49-.53-.72c-.06-.07-.11-.14-.17-.21c-.24-.29-.5-.57-.77-.83c-.06-.06-.12-.11-.18-.16c-.22-.21-.46-.41-.69-.6c-.05-.04-.09-.08-.14-.12c-.04-.03-.09-.06-.14-.1c-.19-.14-.38-.28-.58-.41l-.27-.18c-.29-.18-.59-.35-.9-.5c-2.2-1.08-4.78-1.39-7.15-.77c-.46.12-.92.28-1.35.49c-.22.1-.43.22-.64.34c-.61.37-1.16.85-1.56 1.41c-.13.19-.25.39-.35.59s-.18.43-.25.66c.87.34 1.87.14 2.78.58c.88.43 1.72 1 2.64 1.3c.31.1.62.17.94.19c.33.02.67 0 1-.01c.17-.01.34-.02.5-.02c.09.04.15.07.15.07c.07.09.11.19.15.28c.24.73-.38 1.67-1 2.73c-.08.13-.15.27-.23.41c-.11.2-.21.4-.31.6c-.1.2-.19.41-.26.62c-.06.16-.1.32-.14.48c-.11.49-.14.99-.02 1.5a7.539 7.539 0 0 0 .35 1.08s.28-.48.72-.92c.07-.08.15-.15.24-.22c.13-.11.26-.21.4-.29c.14-.08.28-.14.43-.18c.11-.03.21-.05.32-.05c.26-.01.54.07.82.28c.06.04.1.08.15.13a1.199 1.199 0 0 1 .22.23c.03.04.07.07.09.11c.03.04.05.08.07.12c.02.04.05.08.07.11c.02.04.03.09.05.13c.01.04.03.08.04.11c.01.04.02.09.02.13c.01.04.02.08.02.12v.25c0 .05-.01.09-.02.14c-.01.04-.01.08-.02.12c-.01.05-.03.1-.04.14c-.01.04-.02.07-.04.11c-.02.05-.04.1-.07.15c-.02.04-.03.07-.05.11c-.02.05-.05.09-.08.14c-.02.04-.04.07-.07.11c-.03.05-.07.09-.1.14c-.03.03-.05.07-.07.1l-.12.15c-.03.03-.05.06-.08.09c-.04.05-.09.09-.13.14l-.09.09c-.05.04-.1.09-.14.13c-.03.03-.06.06-.1.09c-.06.05-.12.1-.19.15c-.02.02-.04.03-.07.05c-.09.07-.18.13-.27.19c-1.5 1.02-1.9-.05-1.98.6c-.1.16-.24.56-.37.95l-.01.02c-.17.49-.31.97-.31.97h.01l-.18.58c-.15.77-.01 1.68.81 2.51c.4.41 1.15.61 1.6.7c.15.43.51 1.17 1.25 1.56c.32.17.67.26 1.05.26c.39 0 .8-.09 1.24-.27l.82-.33s-1.13-.45-1.08-1.72c1.61 1.2 3.32-.18 3.36-.22l.62-.56l-.76-.29c-.29-.1-.81-.44-.9-.73c-.35-1.03.42-1.52.49-1.58z",
    fill: "url(#IconifyId17ecdb2904d178eab16176)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16177",
    gradientUnits: "userSpaceOnUse",
    x1: 311.098,
    y1: -821.341,
    x2: 311.098,
    y2: -827.962,
    gradientTransform: "matrix(.7332 .68 .68 -.7332 405.238 -786.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#262626"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.17 29.74c-.85 1.25-4.62 1.93-4.8 2.05c-.32.18 1.08 1.11 1.54 1.04s3.66.3 7.36-1.39c1.66-.76 5.81-2.98 5.81-2.98l-1.31-2.66s-5.2 5.43-6.68 4.25s3-6.87 3-6.87l-4.44-1.22s.05 7.01-.48 7.78z",
    fill: "url(#IconifyId17ecdb2904d178eab16177)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab16178",
    cx: 227.224,
    cy: -719.267,
    r: 18.419,
    gradientTransform: "scale(1 -1) rotate(-37.859 1180.295 -138.985)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81d4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5eb3e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#3c92d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f85cc"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.03 9.88c-1.3-.46-5.8-1.39-9.34.3c-1.49.71-2.93 1.63-4.05 2.83c-.61.66-1.6 1.9-1.51 2.96c.06.73.58 1.08 1.05 1.3c.88.42 3.41 1.09 4.02 1.48c1.4.9 1.64 2.61 1.75 2.99c.4 1.34.97 2.4 3.3 2.4c1.39 0 1.99-.36 2.87.11c.61.32 1.37 1.05 1.16 3.4c-.24 2.61 1.06 3.85 2.41 3.71c1.86-.19 8.33-4.2 7.16-11.39c-.78-4.67-4.36-8.52-8.82-10.09z",
    fill: "url(#IconifyId17ecdb2904d178eab16178)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16179",
    gradientUnits: "userSpaceOnUse",
    x1: 63.622,
    y1: 56.84,
    x2: 44.226,
    y2: 57.398,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0bb95"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.02 60.92c.75-2.36 3.36-3.87 5.79-3.55l23.4 3.08l-1.92 11.32l-19.81-4.36l-7.03 16.66l-6.96-2.46c-.01.01 6.27-19.85 6.53-20.69z",
    fill: "url(#IconifyId17ecdb2904d178eab16179)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M46.45 81.62l-7.33-2.57l-1.76 7.04l6.39 2.25z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1 67.28c.63-3.72-1.87-7.25-5.59-7.88v-.01l-15.65-2.23L56.68 70l15.54 2.87c3.71.64 7.24-1.87 7.88-5.59z",
    fill: "#646464"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83 93.1c.35.42.98.48 1.39.13l1.84-1.55c1.25-1.05 1.6-3.53 1.6-3.53l-4.37-5.21l-4.38-2.45a3.436 3.436 0 0 0-3.84.35l-.83.69c-.36.3-.41.85-.1 1.22l8.69 10.35z",
    fill: "#4568ad"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16180",
    gradientUnits: "userSpaceOnUse",
    x1: 72.098,
    y1: 63.203,
    x2: 61.912,
    y2: 29.854,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0bb95"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 84.01c1.13-1.93 11.92-20.33 11.92-20.33l9.62 6.27l-12.4 17.16l3.44 19.82l-7.18 1.7l-5.85-20.1c-.01 0-.68-2.59.45-4.52z",
    fill: "url(#IconifyId17ecdb2904d178eab16180)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M68.6 104.32l-7.56 1.8l2.96 8.47l5.97-3.16z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.07 59.79a6.828 6.828 0 0 0-9.45 1.99l-8.28 13.47l10.91 7.11l8.82-13.12c2.05-3.15 1.16-7.39-2-9.45z",
    fill: "#7c7c7c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.87 116.51c.54-.27.77-.92.51-1.46l-1.17-2.38c-.79-1.62-3.35-2.65-3.35-2.65L61 114.5l-2.69 2.86c-1.06 1.15-1.32 2.82-.65 4.21l.52 1.08c.23.47.8.67 1.28.43l13.41-6.57z",
    fill: "#4568ad"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab16181",
    cx: 27.251,
    cy: -177.335,
    r: 13.003,
    gradientTransform: "matrix(.9804 .1969 .218 -1.0857 84.659 -146.478)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f78c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#f37f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#ed6d23"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.82 34.69c-4.57-.32-6.5 3.78-6.5 7.5c0 7.91 1.14 12.39.38 19.91c-.05.51 2.26 3.44 6.82 5.02c6.35 2.2 10.65-.3 10.65-.74c0-4.42-.98-16.08-4.2-25.22c-1.81-5.17-2.75-6.15-7.15-6.47z",
    fill: "url(#IconifyId17ecdb2904d178eab16181)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.56 15.28c-.43-.72-1.12-1.08-1.84-.65c-.72.43-.66 1.24-.23 1.96l2.97 5.47c.02.04.05.07.08.11c.88-.43 1.75-1.07 2.52-1.69l-3.5-5.2z",
    fill: "#c48e6a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.93 21.16l.51-.71l-1.36-5.73c-.14-.58-.38-1.11-.73-1.6l-1.7-2.36a4.37 4.37 0 0 0-.84-.88c-.6-.49-1.71-1.36-2.33-1.73c-.34-.2-.74-.36-1.31-.18c-.44.14-.76.45-.93.87c-.18.45-.13.98.13 1.46c.31.57 1.09 1.04 1.69 1.33c.11.05.19.14.24.24l1.29 2.67c.09.18.14.36.16.55c.03.28.09.57.16.9c.16.78.37 1.74.27 3.41c-.13 2.13.67 3.44.71 3.5l.34.28l.39-.21c.02-.01.2-.36.15-.52c0 0-.02-.05-.04-.12c.62-.35 1.91-1.11 2.82-1.79c.17.29.38.62.38.62z",
    fill: "#ba8f63"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16182",
    gradientUnits: "userSpaceOnUse",
    x1: 61.797,
    y1: 82.79,
    x2: 45.527,
    y2: 82.79,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0bb95"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.17 45.74l-2.22-5.91a.546.546 0 0 0-.26-.28a.459.459 0 0 0-.38-.01l-10.59 3.97l-11.36-2.55c-1-.28-2.07.34-2.58 1.53c-.47 1.1-.37 2.62.93 3.38l11.73 4.87c.06.02.12.04.18.04a3.684 3.684 0 0 0 2.05-.01c.06 0 .12 0 .18-.03l12.02-4.35c.13-.04.23-.14.28-.26a.53.53 0 0 0 .02-.39z",
    fill: "url(#IconifyId17ecdb2904d178eab16182)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.91 42.17l3.64 9.2L72.09 48a4.574 4.574 0 0 0 2.57-5.93l-.28-.71a4.574 4.574 0 0 0-5.93-2.57l-8.54 3.38z",
    fill: "#ed6d23"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16183",
    gradientUnits: "userSpaceOnUse",
    x1: 61.797,
    y1: 87.716,
    x2: 45.527,
    y2: 87.716,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0bb95"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.24 37.17a3.01 3.01 0 0 0-1.09-.98l-1.99-1.02c-.3-.15-.62-.25-.97-.3c-.76-.1-1.78-.21-2.36-.18c-.47.02-.78.18-1.1.53c-.34.38-.51.86-.46 1.33c.04.4.24.75.56.98c.37.27.99.35 1.84.23c.05-.01.09 0 .11.02l1.76 1.49c.1.08.17.18.23.3c.1.22.23.43.38.67c.33.53.75 1.2 1.12 2.58c.49 1.85 1.28 2.33 2.11 2.85l.4.2l-.21-.76c.01-.02.1-.12.24-.34c-.14-.1-.26-.25-.37-.36c-.01-.01-.02-.03-.03-.04c.46-.69 1.13-1.72 1.61-2.57v.01s.16.04.25.03c.1-.01.2 0 .29.02c.09-.17.17-.33.24-.48l.12-.26l-2.68-3.95z",
    fill: "url(#IconifyId17ecdb2904d178eab16183)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16184",
    gradientUnits: "userSpaceOnUse",
    x1: 61.797,
    y1: 87.192,
    x2: 45.527,
    y2: 87.192,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0bb95"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.55 40.12l-4.04-1.25c-.39-.16-.75-.15-1.07-.03c-.32.12-.56.37-.7.71c-.28.67.08 1.33.88 1.63l3.84 1.64s.01 0 .02.01c.03.01.09.03.11.03c.17.04.38-.03.45-.17c.12-.25.14-.32.14-.32l-.02-.01l.52-1.48h.01c.08-.27.06-.13.11-.34c.05-.18-.06-.36-.25-.42z",
    fill: "url(#IconifyId17ecdb2904d178eab16184)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab16185",
    gradientUnits: "userSpaceOnUse",
    x1: 15.922,
    y1: 130.435,
    x2: 31.75,
    y2: 32.969,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#795548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#6c4b40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d4037"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab16185)",
    d: "M43.22 25.49l-6.13 10.07l1.5 1.71l-4.72 9.25l3.46 10.97l.01.04l-5.24 9.29l-.35 15.63l2.09 3.5l.01.01l2.49 4.18l1.3 8.23l2.57 16.25l2.8 9.41H4.06v-120h41.22l4.79 8.54l.97 1.74z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4e342e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.26 124.03L29.4 92.31l1.55 31.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 124.03h1.67l-3.53-39.95l-8.35-49.96l5.39 68.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14 124.03L4.79 114l-.64-50.64l-.09 1.23v59.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.94 4.03l-9.48 26.26l-2.75-26.26h-4.58l1.1 14.09l7.52 32.72l9.17-46.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.34 57.53l-5.24 9.29l1.73-11.06l3.5 1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.04 14.31l-7.82 11.18l4.86-11.05l.19-3.16l1.8 1.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.37 101.09l4.81-5.76l-8.29-12.25z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.78 63.52c-2.23 2.3-6.59.98-9.37-.03c-2.98-1.08-8.13-4.89-8.08-5.68c.04-.74 0-1.92.46-2.09c.58-.21 1.22-.31 2.45.53c4.66 3.17 6.67 5.59 12.75 4.65c1.12-.17 1.43-1.09 1.65-1.62c.27-.66 1.19 3.16.14 4.24z",
    fill: "#1b75bc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimbing);
export default __webpack_public_path__ + "static/media/climbing.e5a6342b1232c6491d3cf585ed7e028c.svg";
export { ForwardRef as ReactComponent };